@use 'src/globals/main';

pn-progress-stepper {
  display: block;
}

pn-progress-stepper .pn-progress {
  position: relative;

  width: 100%;
  background: main.$gray50;
  height: 0.5em;
  border-radius: 0.5em;
  box-shadow: (0 0 0 0.0625em main.$gray400);

  &-label {
    display: block;
    color: main.$gray900;
    font-size: 1em;
    margin-bottom: 0.5em;
  }

  &-value {
    position: absolute;
    top: -0.0625em;
    left: -0.0625em;

    height: 0.625em;
    background-color: main.$blue700;
    width: calc(var(--pn-progress-value) + 0.125em);
    border-radius: 0.5em 0 0 0.5em;

    @include main.pn-transition('width, border-radius', main.$timing-layout);

    &[data-full] {
      border-top-right-radius: 0.5em;
      border-bottom-right-radius: 0.5em;
    }
  }

  &-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
  }

  &-dot {
    width: 0.875em;
    height: 0.875em;
    background-color: main.$gray50;
    border: 0.0625em solid main.$gray200;
    border-radius: 50%;

    transform: scale(1) translateY(0%);

    @include main.pn-transition('background-color, border-color', main.$timing-layout);

    // Default state - plays backwards animation when data-active is removed
    animation: pnBackwards main.$timing main.$easing;
    animation-fill-mode: forwards;

    &[data-active] {
      background-color: main.$blue700;
      border-color: main.$blue700;
      animation: pnForward main.$timing main.$easing;
      animation-fill-mode: forwards;
    }
  }

  @include main.pn-sr-only-class();
}

@keyframes pnForward {
  0% {
    transform: scale(1) translateY(0%);
  }
  50% {
    transform: scale(1) translateY(20%);
  }
  75% {
    transform: scale(1.1) translateY(10%);
  }
  100% {
    transform: scale(1) translateY(0%);
  }
}

@keyframes pnBackwards {
  0% {
    transform: scale(1) translateY(0%);
  }
  50% {
    transform: scale(1) translateY(-20%);
  }
  75% {
    transform: scale(0.9) translateY(-10%);
  }
  100% {
    transform: scale(1) translateY(0%);
  }
}
